import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { tap } from 'rxjs';
import { Configuration } from 'src/app/types/configuration';
import { APP_BASE_HREF } from '@angular/common';

export class ConfigurationInitializationError extends Error {}

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private config?: Configuration;

  constructor(
    private readonly http: HttpClient,
    @Inject(APP_BASE_HREF) private readonly baseHref: string,
  ) {}

  load() {
    return this.http.get<any>(`${this.baseHref}assets/appConfig.json`).pipe(
      tap((config) => {
        const not_so_secret = config.secrets;
        if (not_so_secret) {
          delete config['secrets'];
          config = { ...config, ...not_so_secret };
        }
        this.config = config as Configuration;
      }),
    );
  }

  get app() {
    if (!this.config) {
      throw new ConfigurationInitializationError();
    }

    return this.config;
  }
}
